import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LigneOrdonnanceLibre } from 'src/app/utils/interfaces/new/ligne-ordonnance-libre';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.fragment.html',
  styleUrls: [
    './add-product.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class AddProductFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public nomProduit: string;
  public idProduit: string;
  public modalTitle: string = 'Ajout médicament';
  public formGroup: FormGroup;
  public posologieForm: string;
  public listRythmePrise = [{ id: 'minute', libelle: 'minute' }, { id: 'heure', libelle: 'heure' }, { id: 'demi-journée', libelle: 'demi-journée' }, { id: 'jour', libelle: 'jour' }, { id: 'semaine', libelle: 'semaine' }, { id: 'quinzaine', libelle: 'quinzaine' }, { id: 'mois', libelle: 'mois' }, { id: 'trimestre', libelle: 'trimestre' }];

  @Output() public closeEmitter = new EventEmitter();
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddProductModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {

    this.formGroup = this._formBuilder.group({
      freeEntry: [false],
      nom: [this.nomProduit ? this.nomProduit : ''],
      motif: [''],
      matin: [''],
      dix: [''],
      midi: [''],
      seize: [''],
      soir: [''],
      coucher: [''],
      nuit: [''],
      nbrJours: [''],
      nbrBoites: [''],
      uniteBoites: [''],
      rythmePrises: [''],
      freePosologie: [this.posologieForm ? this.posologieForm : ''],
    });
  }

  public posologie() {
    this.posologieForm = '';
    this.posologieForm += this.formGroup.get('matin').value ? `${this.formGroup.get('matin').value} ${this.formGroup.get('uniteBoites').value} le matin,` : '';
    this.posologieForm += this.formGroup.get('dix').value ? ` ${this.formGroup.get('dix').value} ${this.formGroup.get('uniteBoites').value} à 10h,` : '';
    this.posologieForm += this.formGroup.get('midi').value ? ` ${this.formGroup.get('midi').value} ${this.formGroup.get('uniteBoites').value} à midi,` : '';
    this.posologieForm += this.formGroup.get('seize').value ? ` ${this.formGroup.get('seize').value} ${this.formGroup.get('uniteBoites').value} à 16h,` : '';
    this.posologieForm += this.formGroup.get('soir').value ? ` ${this.formGroup.get('soir').value} ${this.formGroup.get('uniteBoites').value} le soir,` : '';
    this.posologieForm += this.formGroup.get('coucher').value ? ` ${this.formGroup.get('coucher').value} ${this.formGroup.get('uniteBoites').value} au coucher,` : '';
    this.posologieForm += this.formGroup.get('nuit').value ? ` ${this.formGroup.get('nuit').value} ${this.formGroup.get('uniteBoites').value} la nuit,` : '';
    this.posologieForm += this.formGroup.get('rythmePrises').value ? ` tous les ${this.formGroup.get('rythmePrises').value}(s),` : '';
    this.posologieForm += this.formGroup.get('nbrJours').value && this.formGroup.get('rythmePrises').value ? ` pendant ${this.formGroup.get('nbrJours').value} ${this.formGroup.get('rythmePrises').value}(s).` : '';
  }

  public async onSubmit() {
    this.formGroup.markAllAsTouched();
    let object: LigneOrdonnanceLibre;
    if (this.formGroup.get('freeEntry').value) {
      object = {
        nomProduit: this.formGroup.get('nom').value,
        posologie: this.formGroup.get('freePosologie').value
      }
    } else {
      object = {
        idOrdonnanceLibre: '',
        idProduit: this.idProduit ? this.idProduit : '',
        nomProduit: this.formGroup.get('nom').value,
        matin: this.formGroup.get('matin').value ? this.formGroup.get('matin').value.replace(',', '.') : '',
        dixHeure: this.formGroup.get('dix').value ? this.formGroup.get('dix').value : '',
        midi: this.formGroup.get('midi').value ? this.formGroup.get('midi').value : '',
        seizeHeure: this.formGroup.get('seize').value ? this.formGroup.get('seize').value : '',
        soir: this.formGroup.get('soir').value ? this.formGroup.get('soir').value : '',
        coucher: this.formGroup.get('coucher').value ? this.formGroup.get('coucher').value : '',
        nuit: this.formGroup.get('nuit').value ? this.formGroup.get('nuit').value : '',
        uniteDuree: this.formGroup.get('rythmePrises').value ? this.formGroup.get('rythmePrises').value.toString() : '',
        duree: this.formGroup.get('nbrJours').value ? parseFloat(this.formGroup.get('nbrJours').value) : 0,
        uniteDose: this.formGroup.get('uniteBoites').value ? this.formGroup.get('uniteBoites').value : '',
        boite: this.formGroup.get('nbrBoites').value ? parseFloat(this.formGroup.get('nbrBoites').value) : 0,
        posologie: this.posologieForm,
        motif: this.formGroup.get('motif').value ? this.formGroup.get('motif').value : '',
      }
    }
    this.closeAddProductModal(object);
  }


  public closeAddProductModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }
}
